import InstagramDirectIntegration from './instagramDirectIntegration.component';
import InstagramIntegration from './instagramIntegration.component';
import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Box,
  styled,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { CommonHelper } from 'src/utils/commonHelper';

const StyledListItem = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  transition: 'background-color 0.2s ease-in-out',
  cursor: 'pointer'
}));

const InstagramCommonIntegration = (props) => {
  const { t: translate } = useTranslation();
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");
  const [selectedOption, setSelectedOption] = useState("facebook");
  const [instagramIntegrationOpen, setInstagramIntegrationOpen] = useState(false);
  const [instagramDirectIntegrationOpen, setInstagramDirectIntegrationOpen] = useState(false);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };
  const handleInstagram = (show = false) => {
    setInstagramIntegrationOpen(show);
    handleClose();
  };
  const handleDirectInstagram = (show = false) => {
    setInstagramDirectIntegrationOpen(show);
    handleClose();
  };
  const handleProceed = () => {
    if (selectedOption === 'instagram') {
      setInstagramDirectIntegrationOpen(true);
    } else if (selectedOption === 'facebook') {
      setInstagramIntegrationOpen(true);
    }
  };
  const handleClose = () => {
    props.handleClose();
  };
  return (
    <>
      <Dialog onClose={handleClose} open={true}>
        <DialogTitle>{translate('instagram_common_integration.title')}</DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle1" gutterBottom>
            {translate('instagram_common_integration.subtitle')}
          </Typography>

          {(!isCustomDomain || isPortalAdmin) && (
            <Box display="flex" justifyContent="center" mb={1}>
              <Button
                variant="outlined"
                startIcon={<YouTubeIcon />}
                onClick={() => window.open('https://www.youtube.com/watch?v=GkrXcPFJ57U', '_blank')}
                color="primary"
              >
                {translate('common.tutorial')}
              </Button>
            </Box>
          )}

          <List>
            <StyledListItem 
             onClick={() => handleOptionChange('instagram')}
            >
              <Checkbox checked={selectedOption === 'instagram'} />
              <ListItemText
                primary={
                  <Box display="flex" alignItems="center">
                    <Typography variant="body1">{translate('instagram_common_integration.instagram_option_primary')}</Typography>
                    <Box ml={1} display="flex" alignItems="center" color="primary.main">
                      <NewReleasesIcon fontSize="small" />
                      <Typography variant="caption" ml={0.5}>
                        {translate('instagram_common_integration.instagram_option_new')}
                      </Typography>
                    </Box>
                  </Box>
                }
                secondary={
                  <>
                    <Typography variant="body2" color="text.secondary">
                      {translate('instagram_common_integration.instagram_option_secondary_1')}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" fontStyle="italic">
                      {translate('instagram_common_integration.instagram_option_secondary_2')}
                    </Typography>
                  </>
                }
                secondaryTypographyProps={{ component: 'div' }}
              />
              <InstagramIcon color="primary" sx={{ ml: 2 }} />
            </StyledListItem>

            <StyledListItem onClick={() => handleOptionChange('facebook')}>
              <Checkbox checked={selectedOption === 'facebook'} />
              <ListItemText
                primary={translate('instagram_common_integration.facebook_option_primary')}
                secondary={translate('instagram_common_integration.facebook_option_secondary')}
                secondaryTypographyProps={{ color: 'text.secondary' }}
              />
              <FacebookIcon color="primary" sx={{ ml: 2 }} />
            </StyledListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button color="error" variant="outlined" onClick={handleClose}>
            {translate('instagram_common_integration.cancel_button')}
          </Button>
          <Button onClick={handleProceed} variant="contained" color="primary" disabled={!selectedOption}>
            {translate('instagram_common_integration.proceed_button')}
          </Button>
        </DialogActions>
      </Dialog>
      {instagramIntegrationOpen && <InstagramIntegration handleClose={handleInstagram} />}
      {instagramDirectIntegrationOpen && <InstagramDirectIntegration handleClose={handleDirectInstagram} />}
    </>
  );
};

export default InstagramCommonIntegration;
